// extracted by mini-css-extract-plugin
export var growableInput = "_7a-0";
export var tagContainer = "_7a-2";
export var textInput = "_7a-1";